export default __webpack_public_path__ + "static/rectangle-9c47de01c7f5f1c1449a2f350dfe6b8b.svg";